import { render, staticRenderFns } from "./FieldTypePicker.vue?vue&type=template&id=1a49f580&scoped=true&"
import script from "./FieldTypePicker.vue?vue&type=script&lang=js&"
export * from "./FieldTypePicker.vue?vue&type=script&lang=js&"
import style0 from "./FieldTypePicker.vue?vue&type=style&index=0&id=1a49f580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a49f580",
  null
  
)

export default component.exports